import { render, staticRenderFns } from "./subCategory.vue?vue&type=template&id=5d67ba70&scoped=true"
import script from "./subCategory.vue?vue&type=script&lang=js"
export * from "./subCategory.vue?vue&type=script&lang=js"
import style0 from "./subCategory.vue?vue&type=style&index=0&id=5d67ba70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d67ba70",
  null
  
)

export default component.exports